<template>
    <div>
      <slot :data="cData" :loading="loading" :empty="empty"></slot>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <!-- <div slot="spinner">Loading...</div> -->
        <div slot="no-more" class="nomore_data">
          <span v-if="text != ''">{{text}}</span>
        </div>
        <div slot="no-results" class="noresult_data">
          <van-image class="no_goods" :src="require('../assets/bx/acc/no_goods.png')"/> 
          <span>{{ nrtxt }}，<a href="javascript:;" @click="refresh">点击刷新</a></span>
        </div>
        <div slot="error" class="result_error" slot-scope="{ trigger }">
          出错了，请刷新&nbsp;&nbsp;<a class="here" href="javascript:;" @click="refresh">here</a>
        </div>
      </infinite-loading>
    </div>
  </template>
  
  <script>
    import {
      debounce
    } from 'riku-verycloud'
    import InfiniteLoading from "vue-infinite-loading";
    export default {
      name: "order-scroll",
      components: {
        InfiniteLoading,
      },
      data() {
        return {
          page: 1,
          data: [],
          loading: 0,
          infiniteId: 1,
        };
      },
      //返回时要修改
      props: {
        text: {
          type: String,
          default: "暂无更多",
        },
        pagesize: {
          type: Number,
          default: 10,
        },
        url: {
          type: String,
          required: true,
        },
        params: {
          type: Object,
          default () {
            return {};
          },
        },
        nrtxt: {
          type: String,
          default: "暂无记录",
        },
        computeData: Function,
        method: {
          type: String,
          default: "post",
        }
      },
      computed: {
        sendData() {
          return {
            ...this.params,
            page: this.page
          };
        },
        trigger() {
          return this.url + "?" + this.$QueryString.stringify(this.params);
        },
        cData() {
          return (
            (typeof this.computeData === "function" ?
              this.computeData(this.data) :
              this.data) || []
          );
        }, 
        empty() {
          return !this.cData.length;
        },
      },
      methods: {
        infiniteHandler: debounce(function ($state) { 
            this.loading++;
            this.$Ajax(this.url, this.sendData, this.method)
              .then(rs => {
                this.page++;
                if (
                  rs.code == 200 && 
                  rs.data.list instanceof Array &&
                  rs.data.list.length > 0
                ) {
                  this.$emit("on-fetch", {
                    data: rs.data.list,
                    total: rs.data.page_info.total,
                    status_maps: rs.data.status_maps?rs.data.status_maps : {},
                  });
                  this.data.push(...rs.data.list);
                  $state.loaded();
                } 
                if (rs.data.length == 0 ||rs.data.page_info.total == 0 || this.page > Math.ceil(Number(rs.data.page_info.total) / Number(rs.data.page_info.page_size))) {
                  $state.complete();
                }
              })
              .finally(() => {
                this.loading--;
              });

        }),
        refresh() {
          this.page = 1;
          this.data = [];
          this.infiniteId++;
        },
      },
      watch: {
        trigger: "refresh",
      },
    };
  </script>
  
  <style lang="less" scoped>
    .nomore_data,
    .noresult_data,
    .result_error {
      color: #aaa;
      font-size: 1.4rem;
      padding: 1rem 0;
  
      .van-divider {
        margin: 0;
        font-size: 1.2rem;
        line-height: unset;
      }
  
      .van-icon-warning {
        font-size: 1.4rem;
        margin-right: 0.6rem;
      }
  
      .here {
        color: var(--theme);
      }
    }
    .no_goods {
      display: block;
      margin: 2rem auto .7rem;
      width: 21rem;
      height: 13.4rem;
    }
    .noresult_data {
      a {
        color: var(--theme);
        text-decoration: underline;
      }
    }
  </style>
